import React, { useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

import Button, { ButtonClose } from '~/components/Button';
import { checkIcon, xIcon } from '~/assets/icons';
import { BASIC_FEATURES, PREMIUM_FEATURES } from '~/constants';
import Carousel from './Carousel';
import styles from './Pricing.module.scss';

const cx = classNames.bind(styles);
function Pricing({ onClose }) {
    const [isYearly, setIsYearly] = useState(true);

    return (
        <div className={cx('Pricing')}>
            <ButtonClose className={cx('pos')} onClick={onClose} />

            <div className={cx('left-col')}>
                <h3 className={cx('title')}>Consigue más con premium</h3>

                <div className={cx('options')}>
                    <p style={{ opacity: isYearly ? 0.4 : 1 }}>Pago mensual</p>
                    <Switch
                        height={30}
                        width={56}
                        checked={isYearly}
                        onChange={(checked) => setIsYearly(checked)}
                        checkedIcon={false}
                        uncheckedIcon={false}
                        onColor="#24242f"
                        offColor="#24242f"
                        onHandleColor="#f3a952"
                        offHandleColor="#f3a952"
                        handleDiameter={25}
                        activeBoxShadow="0 0 0 0 transparent"
                    />
                    <p style={{ opacity: isYearly ? 1 : 0.4 }}>Pago anual</p>
                    <div className={cx('save-label')} style={{ opacity: isYearly ? 1 : 0 }}>
                        Ahorra 25%
                    </div>
                </div>

                <div className={cx('plans')}>
                    <div className={cx('plan-basic', 'box')}>
                        <h3 className={cx('plan-name')}>Básico</h3>
                        <p className={cx('price')}>$0</p>
                        <p className={cx('guarantee-note')}>
                            <br />
                        </p>
                        <Button type={'rounded'} className={cx('basic-btn')}>
                            Plan actual
                        </Button>
                        <div className={cx('features-list')}>
                            {BASIC_FEATURES.map((item, index) => (
                                <div
                                    key={index}
                                    className={cx('feature', {
                                        disabled: !item.checked,
                                    })}
                                >
                                    {item.checked ? (
                                        <img src={checkIcon} alt="checked" />
                                    ) : (
                                        <img src={xIcon} alt="cross" />
                                    )}
                                    <p>{item.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={cx('plan-premium', 'box')}>
                        <h3 className={cx('plan-name')}>Premium</h3>
                        <p className={cx('price')}>
                            {isYearly ? '$2,99' : '$3.99'} <span>/ mes</span>
                        </p>
                        <p className={cx('guarantee-note')}>*7 días de garantía de reembolso</p>
                        <Button type={'rounded'} className={cx('premium-btn')}>
                            Mejorar plan
                        </Button>
                        <div className={cx('features-list')}>
                            {PREMIUM_FEATURES.map((item, index) => (
                                <div
                                    key={index}
                                    className={cx('feature', {
                                        disabled: !item.checked,
                                    })}
                                >
                                    {item.checked ? (
                                        <img src={checkIcon} alt="checked" />
                                    ) : (
                                        <img src={xIcon} alt="cross" />
                                    )}
                                    <p>
                                        {item.accent && <span className={cx('accent')}>{item.accent} </span>}
                                        {item.text}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={cx('more-info')}>*El 1% de cada venta apoya organizaciones de salud mental en todo el mundo</div>
            </div>
            <div className={cx('right-col')}>
                <h3 className={cx('title')}>
                    Únete a la familia <span className={cx('accent')}>lofi.co</span>
                </h3>
                <div className={cx('box')}>
                    <h3 className={cx('accent')}>+150.000</h3>
                    <p>Usuarios relajándose cada mes</p>
                </div>
                <h3 className={cx('title')}>¿No te convencen los números?</h3>
                <h6>Lee lo que dicen nuestros usuarios en redes sociales.</h6>

                <div className={cx('mosaic')}>
                    <Carousel />
                </div>
            </div>
        </div>
    );
}
Pricing.propsType = {
    onClose: PropTypes.func.isRequired,
};

export default Pricing;
